








































































import { RelatorioService } from "@/services/relatorio.service";
import DatePickerCalendar from "@/shared/components/date-picker-calendar.vue";
import Warning from "@/shared/components/warning.vue";
import { dateTime } from "@/shared/filters";
import { rangeDateIsValid, validPeriod } from "@/shared/validators";
import dayjs from "dayjs";
import { Component, Vue } from "vue-property-decorator";
import * as XLSX from "xlsx";

// `key` precisa casar com o nome serializado pela API (camelCase). O backoffice
// serializa com NullValueHandling.Ignore, então propriedades nulas não vêm no
// JSON — sem a lista explícita de chaves o json_to_sheet monta as colunas a
// partir do que existe em cada linha e os títulos passam a rotular a coluna
// errada.
interface ColunaRelatorio {
  key: string;
  titulo: string;
  largura: number;
}

@Component({
  components: {
    DatePickerCalendar,
    Warning,
  },
  filters: { dateTime },
})
export default class RelatoriosDeClientes extends Vue {
  loading = false;
  tipoRelatorio: string | null = null;
  periodoInicial: string | null = null;
  periodoFinal: string | null = null;

  rules = {
    periodo: [validPeriod(), rangeDateIsValid(365)],
  };

  colunasDoRelatorio(
    tipoRelatorio: string,
    maxWidth: number
  ): ColunaRelatorio[] | null {
    switch (tipoRelatorio) {
      case "ClienteLogouComPlanoExpirado":
        return [
          { key: "idConsultor", titulo: "Id Cliente", largura: 10 },
          { key: "nome", titulo: "Nome", largura: maxWidth },
          { key: "telefone", titulo: "Telefone", largura: 16 },
          { key: "celular", titulo: "Celular", largura: 16 },
          { key: "receberWhatsapp", titulo: "Receber Whatsapp", largura: 20 },
          { key: "dataContratacao", titulo: "Data de Contratação", largura: 20 },
          { key: "dataExpiracao", titulo: "Data de Expiração", largura: 20 },
          {
            key: "dataUltimoAcesso",
            titulo: "Data do Último Acesso",
            largura: 20,
          },
          { key: "descricao", titulo: "Nome do Plano", largura: maxWidth },
          {
            key: "meioPagamentoAssinatura",
            titulo: "Meio de Pagamento da Assinatura",
            largura: maxWidth,
          },
          {
            key: "motivoCancelamento",
            titulo: "Motivo de Cancelamento da Assinatura",
            largura: maxWidth,
          },
          { key: "observacao", titulo: "Observação", largura: maxWidth },
        ];

      case "ClienteComPlanoExpiradoNaoRenovou":
        return [
          { key: "idConsultor", titulo: "Id Cliente", largura: 10 },
          { key: "nome", titulo: "Nome", largura: maxWidth },
          { key: "telefone", titulo: "Telefone", largura: 16 },
          { key: "celular", titulo: "Celular", largura: 16 },
          { key: "receberWhatsapp", titulo: "Receber Whatsapp", largura: 20 },
          {
            key: "dataUltimoAcesso",
            titulo: "Data do Último Acesso",
            largura: 20,
          },
          { key: "dataContratacao", titulo: "Data de Contratação", largura: 20 },
          { key: "dataExpiracao", titulo: "Data de Expiração", largura: 20 },
          {
            key: "dataCancelamento",
            titulo: "Data de Cancelamento da Assinatura",
            largura: 20,
          },
          { key: "descricao", titulo: "Nome do Plano", largura: maxWidth },
          {
            key: "meioPagamentoAssinatura",
            titulo: "Meio de Pagamento da Assinatura",
            largura: maxWidth,
          },
          {
            key: "motivoCancelamento",
            titulo: "Motivo de Cancelamento da Assinatura",
            largura: maxWidth,
          },
          { key: "observacao", titulo: "Observação", largura: maxWidth },
        ];

      case "ClientesCadastrados":
        return [
          { key: "idConsultor", titulo: "Id Cliente", largura: 10 },
          { key: "nome", titulo: "Nome", largura: maxWidth },
          { key: "telefone", titulo: "Telefone", largura: 16 },
          { key: "celular", titulo: "Celular", largura: 16 },
          { key: "receberWhatsapp", titulo: "Receber Whatsapp", largura: 20 },
          { key: "dataCadastro", titulo: "Data de Cadastro", largura: 20 },
          {
            key: "dataPrimeiroPagamento",
            titulo: "Data do Primeiro Pagamento",
            largura: 25,
          },
          { key: "dataExpiracao", titulo: "Data de Expiração", largura: 20 },
          {
            key: "dataUltimoAcesso",
            titulo: "Data do Último Acesso",
            largura: 20,
          },
          { key: "descricao", titulo: "Nome do Plano", largura: maxWidth },
          { key: "status", titulo: "Status", largura: 20 },
          {
            key: "meioPagamentoAssinatura",
            titulo: "Meio de Pagamento da Assinatura",
            largura: maxWidth,
          },
          {
            key: "motivoCancelamento",
            titulo: "Motivo de Cancelamento da Assinatura",
            largura: maxWidth,
          },
          { key: "observacao", titulo: "Observação", largura: maxWidth },
        ];

      case "ClientesCadastradosNaoAssinaramPlano":
        return [
          { key: "idConsultor", titulo: "Id Cliente", largura: 10 },
          { key: "nome", titulo: "Nome", largura: maxWidth },
          { key: "dataContratacao", titulo: "Data de Contratação", largura: 20 },
          { key: "dataCadastro", titulo: "Data de Cadastro", largura: 20 },
          { key: "telefone", titulo: "Telefone", largura: 16 },
          { key: "celular", titulo: "Celular", largura: 16 },
          { key: "receberWhatsapp", titulo: "Receber Whatsapp", largura: 20 },
          { key: "email", titulo: "Email", largura: maxWidth },
          {
            key: "dataUltimoAcesso",
            titulo: "Data do Último Acesso",
            largura: 20,
          },
          { key: "descricao", titulo: "Nome do Plano", largura: maxWidth },
          { key: "status", titulo: "Status", largura: 20 },
          { key: "dataExpiracao", titulo: "Data de Expiração", largura: 20 },
          {
            key: "meioPagamentoAssinatura",
            titulo: "Meio de Pagamento da Assinatura",
            largura: maxWidth,
          },
          {
            key: "motivoCancelamento",
            titulo: "Motivo de Cancelamento da Assinatura",
            largura: maxWidth,
          },
          { key: "observacao", titulo: "Observação", largura: maxWidth },
        ];

      case "ClientesPlanoVaiExpirarSemPlanoContratado":
        return [
          { key: "idConsultor", titulo: "Id Cliente", largura: 10 },
          { key: "nome", titulo: "Nome", largura: maxWidth },
          { key: "telefone", titulo: "Telefone", largura: 16 },
          { key: "celular", titulo: "Celular", largura: 16 },
          { key: "receberWhatsapp", titulo: "Receber Whatsapp", largura: 20 },
          { key: "dataUltimoAcesso", titulo: "Último Acesso", largura: 20 },
          { key: "descricao", titulo: "Nome do Plano", largura: maxWidth },
          { key: "dataContratacao", titulo: "Data de Contratação", largura: 20 },
          { key: "dataInicio", titulo: "Data de Início", largura: 20 },
          { key: "dataExpiracao", titulo: "Data de Expiração", largura: 20 },
          {
            key: "meioPagamentoAssinatura",
            titulo: "Meio de Pagamento da Assinatura",
            largura: maxWidth,
          },
          {
            key: "motivoCancelamento",
            titulo: "Motivo de Cancelamento da Assinatura",
            largura: maxWidth,
          },
          { key: "observacao", titulo: "Observação", largura: maxWidth },
        ];

      default:
        return null;
    }
  }

  async gerarRelatorio() {
    if (this.periodoInicial && this.periodoFinal) {
      if (this.tipoRelatorio) {
        const periodo = this.periodoInicial + " - " + this.periodoFinal;
        this.loading = true;

        const relatorioJson = await RelatorioService.GerarRelatorioCliente(
          periodo,
          this.tipoRelatorio
        ).finally(() => {
          this.loading = false;
        });
        const relatorio = relatorioJson.relatorio;

        if (!relatorio || relatorio.length == 0) {
          const modalWarning = this.$refs.warning as Warning;
          const title = "Registros não foram encontrados";
          const text = "Não foi possível encontrar registros de clientes com os dados informados";
          await modalWarning.open(title, text);
        } else {
          relatorio.forEach(function (v: any) {
            if (v.dataCadastro) {
              v.dataCadastro = dayjs(v.dataCadastro).toDate();
            }
            if (v.dataContratacao) {
              v.dataContratacao = dayjs(v.dataContratacao).toDate();
            }
            if (v.dataExpiracao) {
              v.dataExpiracao = dayjs(v.dataExpiracao).toDate();
            }
            if (v.dataUltimoAcesso) {
              v.dataUltimoAcesso = dayjs(v.dataUltimoAcesso).toDate();
            }
            if (v.dataInicio) {
              v.dataInicio = dayjs(v.dataInicio).toDate();
            }
            if (v.dataPrimeiroPagamento) {
              v.dataPrimeiroPagamento = dayjs(v.dataPrimeiroPagamento).toDate();
            }
            if (v.dataCancelamento) {
              v.dataCancelamento = dayjs(v.dataCancelamento).toDate();
            }
          });

          const maxWidth = relatorio.reduce(
            (w: number, r) => Math.max(w, (r.descricao || "").length),
            10
          );

          const colunas = this.colunasDoRelatorio(this.tipoRelatorio, maxWidth);
          if (!colunas) {
            return;
          }

          const worksheet = XLSX.utils.json_to_sheet(relatorio, {
            header: colunas.map((c) => c.key),
            cellDates: true,
            dateNF: "dd/mm/yyyy",
          });

          XLSX.utils.sheet_add_aoa(worksheet, [colunas.map((c) => c.titulo)], {
            origin: "A1",
          });

          worksheet["!cols"] = colunas.map((c) => ({ wch: c.largura }));

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Relatorio");

          XLSX.writeFile(workbook, this.tipoRelatorio + ".xlsx", {cellDates: true});
        }
      } else {
        const modalWarning = this.$refs.warning as Warning;
        const title = "Tipo de Relatório não selecionado";
        const text =
          "Favor selecionar o tipo de relatório desejado antes de continuar.";
        await modalWarning.open(title, text);
      }
    } else {
      const modalWarning = this.$refs.warning as Warning;
      const title = "Data Obrigatória";
      const text =
        "Favor preencher os campos de data inicial e data final antes de continuar.";
      await modalWarning.open(title, text);
    }
  }
}
